import request from '@/utils/request'
import { xlsDownload } from '@/api/view/hip/common/commonXls'

export function epms5060Items(param) {
  let data = param
  return request({
    url: `/delivery/epms5060/epms5060Items`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5060(param) {
  let data = param
  return request({
    url: `/delivery/epms5060/epms5060`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5060Save(param) {
  let data = param
  return request({
    url: `/delivery/epms5060/epms5060Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5060Xls(param) {
  const data = param
  return request({
    url: `/delivery/epms5060/epms5060Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms5060XlsRes', res)

    const filename = 'Delivery Plan.xls'
    xlsDownload(filename, res)
  })
}




